const FULL = 'full';
const HALF = 'half';
const HOURS = 'hours';
const FIRST_HALF = 'firstHalf';
const SECOND_HALF = 'secondHalf';

export default Object.freeze({
    [FULL]: -1,
    [HALF]: -2,
    [HOURS]: -3,
    [FIRST_HALF]: -4,
    [SECOND_HALF]: -5,
});
